var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.838679 9.61538V10C0.614294 10 0.398731 9.91691 0.239782 9.76674C-0.0765458 9.4673 -0.0802755 8.98844 0.230873 8.6842L4.00394 4.99984L0.230922 1.31553C-0.0803188 1.01171 -0.0765866 0.53268 0.240031 0.23297C0.572428 -0.0811451 1.11963 -0.0770344 1.44621 0.241766L5.76954 4.46334C6.07686 4.7639 6.07686 5.23578 5.76931 5.53657L1.44639 9.75774C1.28726 9.91331 1.06768 10 0.838679 10V9.61538Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarArrow);
export default __webpack_public_path__ + "static/media/sidebar-arrow.bafc249e3bddff815b0c89281c8e6dff.svg";
export { ForwardRef as ReactComponent };